import React from "@platform/react";
import { Text } from "@front/components/Element/Text";
import { Box } from "@front/components/Element/Box";
import { Component } from "@platform/react-storybook/Component";

import { PatternBox } from "@front/components/Element/Box/Pattern";
import { Link } from "@front/components/Element/Link";

import type { PropTypesSectionCard } from "./types";
import { DEF_SECTION_CARD, NAME_SECTION_CARD, TYPE_SECTION_CARD } from "./types";
import Rules from "./_rules.module.scss";

export function SectionCard(props: PropTypesSectionCard) {
    const {
        bitmap,
        preset,
        title,
        tag,
        desc,
        "desc-preset": descP,
        "data-video": dataV,
        hasPattern,
        "title-preset": titlePreset,
        locked,
        href,
        ...rest
    } = props;

    const replaceText = dataV ? Object.values(dataV) : [];
    const hasTitle = title && titlePreset;
    const hasDesc = desc && descP;
    const showFooter = hasDesc || hasPattern;

    return (
        <Component
            {...rest}
            data-preset={preset}
            name={NAME_SECTION_CARD}
            tag="section"
            type={TYPE_SECTION_CARD}>
            <Box bitmap={bitmap} locked={locked} preset="pinsir">
                <Link to={href}>
                    {tag && (
                        <Box preset="pinsir">
                            <Text preset="lanus" uuid={tag} />
                        </Box>
                    )}
                    <div className={Rules.contentcard}>
                        {hasTitle && (
                            <Text className={Rules.title} preset={titlePreset} uuid={title} />
                        )}
                        {showFooter && (
                            <footer className={Rules.card_footer}>
                                {hasDesc && (
                                    <Text preset={descP} replace={replaceText} uuid={desc} />
                                )}

                                {hasPattern && (
                                    <PatternBox
                                        className={Rules.fill}
                                        fill="colombia"
                                        preset="c"
                                        width={12}
                                    />
                                )}
                            </footer>
                        )}
                    </div>
                </Link>
            </Box>
        </Component>
    );
}
SectionCard.defaultProps = DEF_SECTION_CARD;
